import { defineStore } from 'pinia';
import type { Plan, UserPlan } from '../domain/types/Plan';

interface PlanState {
  availablePlans: Plan[];
  currentPlan: UserPlan | null;
  isLoading: boolean;
  error: string | null;
}

export const usePlanStore = defineStore('plan', {
  state: (): PlanState => ({
    availablePlans: [],
    currentPlan: null,
    isLoading: false,
    error: null
  }),

  getters: {
    isFreeTrial: (state) => {
      if (!state.currentPlan) return false;
      return state.currentPlan.trialEndDate ? new Date(state.currentPlan.trialEndDate) > new Date() : false;
    },
    daysLeftInTrial: (state) => {
      if (!state.currentPlan?.trialEndDate) return 0;
      const trialEnd = new Date(state.currentPlan.trialEndDate);
      const today = new Date();
      const diffTime = Math.abs(trialEnd.getTime() - today.getTime());
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    isPlanActive: (state) => {
      return state.currentPlan?.active === true;
    }
  },

  actions: {
    async fetchAvailablePlans() {
      this.isLoading = true;
      try {
        // Aquí implementarías la lógica para obtener los planes disponibles
        // desde tu backend o Firestore
        this.error = null;
      } catch (error: any) {
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    },

    async upgradePlan(planId: string) {
      this.isLoading = true;
      try {
        // Implementar lógica de actualización de plan
        this.error = null;
      } catch (error: any) {
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    }
  }
});
